document.addEventListener('DOMContentLoaded', () => {
  const searchToggle = document.getElementById('header-search-toggle');
  const searchPanel = document.getElementById('header-search-panel');
  const mobileToggle = document.getElementById('header-mobile-toggle');
  const mobilePanel = document.getElementById('header-mobile-panel');
  const header = document.querySelector('.site-header');

  function togglePanel(button, panel) {
    const isOpen = !panel.hidden;
    panel.hidden = isOpen;
    button.setAttribute('aria-expanded', String(!isOpen));
    if (!isOpen) {
      const input = panel.querySelector('input[type="search"]');
      input && input.focus();
    }
  }

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      togglePanel(searchToggle, searchPanel);
    });
  }

  if (mobileToggle && mobilePanel) {
    mobileToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      togglePanel(mobileToggle, mobilePanel);
    });
  }

  // Close panels when clicking outside
  document.addEventListener('click', (e) => {
    if (searchPanel && !searchPanel.hidden && !searchPanel.contains(e.target) && !e.target.closest('#header-search-toggle')) {
      searchPanel.hidden = true;
      searchToggle.setAttribute('aria-expanded', 'false');
    }
    if (mobilePanel && !mobilePanel.hidden && !mobilePanel.contains(e.target) && !e.target.closest('#header-mobile-toggle')) {
      mobilePanel.hidden = true;
      mobileToggle.setAttribute('aria-expanded', 'false');
    }
  });

  // Escape key closes panels
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (searchPanel && !searchPanel.hidden) {
        searchPanel.hidden = true;
        searchToggle.setAttribute('aria-expanded', 'false');
      }
      if (mobilePanel && !mobilePanel.hidden) {
        mobilePanel.hidden = true;
        mobileToggle.setAttribute('aria-expanded', 'false');
      }
    }
  });

  // Measure real height of marquee + header so page content is always pushed
  // down by the correct amount, on every page
  function updateFixedBarsHeight() {
    const marquee = document.querySelector('.announcement-marquee');
    const marqueeHeight = marquee ? marquee.offsetHeight : 0;
    const headerHeight = header ? header.offsetHeight : 0;
    // small safety buffer in case of sub-pixel rounding differences across browsers
    document.documentElement.style.setProperty('--fixed-bars-height', `${marqueeHeight + headerHeight + 4}px`);
  }

  updateFixedBarsHeight();
  window.addEventListener('resize', updateFixedBarsHeight);

  // Toggle solid header background once the page is scrolled (only relevant
  // on the homepage, where the header starts transparent over the hero)
  if (header) {
    const SCROLL_THRESHOLD = 40;
    let ticking = false;

    function updateHeaderScrollState() {
      header.classList.toggle('is-scrolled', window.scrollY > SCROLL_THRESHOLD);
      ticking = false;
    }

    updateHeaderScrollState();

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderScrollState);
        ticking = true;
      }
    }, { passive: true });
  }

  // Re-measure once everything (including web fonts) has actually finished
  // loading — fonts swapping in after initial load can change the header's
  // rendered height, which would otherwise leave the earlier measurement stale
  window.addEventListener('load', updateFixedBarsHeight);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateFixedBarsHeight);
  }

  // Keep the cart count in the header live as items are added/removed.
  // Hooked at the network level (rather than Dawn's internal pubsub events)
  // so it works reliably across different Dawn versions/customizations.
  function updateCartCount() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        const countEl = document.getElementById('header-cart-count');
        if (!countEl) return;
        countEl.textContent = `(${cart.item_count})`;
        countEl.hidden = cart.item_count === 0;
      })
      .catch(() => {});
  }

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const request = args[0];
    const url = typeof request === 'string' ? request : (request && request.url) || '';
    const fetchPromise = originalFetch.apply(this, args);

    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      fetchPromise.then(() => updateCartCount()).catch(() => {});
    }

    return fetchPromise;
  };

  // Sync on load in case the page was loaded from cache with a stale count
  updateCartCount();
});